import * as types from "_constants";
import { axiosAPI } from "_utils/axios";

export function openDialog(payload) {
  return async (dispatch) => {
    dispatch({ type: types.OPEN_DIALOG, payload });
  };
}

export function hideDialog() {
  return async (dispatch) => {
    dispatch({ type: types.HIDE_DIALOG });
  };
}

export function openNotification(payload) {
  return async (dispatch) => {
    dispatch({ type: types.SHOW_NOTIFICATION, payload });
  };
}

export function hideNotification() {
  return async (dispatch) => {
    dispatch({ type: types.HIDE_NOTIFICATION });
  };
}

export function signOut() {
  return async (dispatch) => {
    localStorage.removeItem('access_token');
    dispatch({
      type: types.AUTH_SIGN_OUT,
    });
  }
}

export function getOrgwebsiteAction() {
  return async (dispatch) => {
    try {
      const access_token = localStorage.getItem("access_token");
      if (access_token) {
        const r = await axiosAPI.get(`/patron/org-details`, {
          headers: {
            Authorization: `Bearer ${access_token}`
          }
        });
        const organizationWebsite = r.data;
        dispatch({
          type: types.GET_ORG_WEBSITE_SUCCESS,
          payload: {
            organizationWebsite: organizationWebsite
          }
        });
      } else {
        throw new Error(`Authorization not found`);
      }
    } catch (error) {
      dispatch({
        type: types.GET_ORG_WEBSITE_ERROR,
        payload: {
          error: error
        }
      });
    }
  };
}
